import React from "react";
import { Link } from "react-router-dom";

// Main columns are the default columns on the applications list page
export const allMainColumns = [
  {
    id: "confirmation_number",
    name: "Application ID",
  },
  {
    id: "permits_type_name",
    name: "Application Type",
  },
  {
    id: "status",
    name: "Status",
  },
  {
    id: "assignee_ids",
    name: "Active assignee",
  },
  {
    id: "active_workflow_steps",
    name: "Active Workflow Steps",
  },
  {
    typesId: "applicant_full_name",
    field_type: 0,
    name: "Applicant Name",
    type: 12,
    contactField: {
      field: "full_name",
      contactType: "applicant",
    },
    hideInMainColumnList: true,
  },
  {
    id: "reservation_number",
    name: "Formal Number",
  },
  {
    id: "created_at",
    name: "Submitted date",
  },
  {
    id: "started_at",
    name: "Start date",
  },
  {
    id: "expired_at",
    name: "Expiration date",
  },
  {
    id: "total_pending",
    name: "Balance",
  },
  {
    id: "subtotal",
    name: "Subtotal",
  },
  {
    id: "total_fee_with_waives_in_cents",
    name: "Total Fees",
  },
  {
    id: "total_paid_in_cents",
    name: "Total Paid",
  },
  {
    id: "renewal_status",
    name: "Renewal Status",
  },
];

export const AllApplicationsQuery =
  "?columns=%5B%7B%22id%22%3A%22confirmation_number%22%2C%22name%22%3A%22Application%20ID%22%7D%2C%7B%22id%22%3A%22permits_type_id%22%2C%22name%22%3A%22Application%20Type%22%7D%2C%7B%22id%22%3A%22status%22%2C%22name%22%3A%22Status%22%7D%2C%7B%22id%22%3A%22assignee_ids%22%2C%22name%22%3A%22Active%20assignee%22%7D%2C%7B%22typesId%22%3A%22applicant_full_name%22%2C%22field_type%22%3A0%2C%22name%22%3A%22Applicant%20Name%22%2C%22type%22%3A12%2C%22contactField%22%3A%7B%22field%22%3A%22full_name%22%2C%22contactType%22%3A%22applicant%22%7D%2C%22hideInMainColumnList%22%3Atrue%7D%2C%7B%22id%22%3A%22reservation_number%22%2C%22name%22%3A%22Formal%20Number%22%7D%2C%7B%22id%22%3A%22created_at%22%2C%22name%22%3A%22Submitted%20date%22%7D%2C%7B%22id%22%3A%22started_at%22%2C%22name%22%3A%22Start%20date%22%7D%2C%7B%22id%22%3A%22expired_at%22%2C%22name%22%3A%22Expiration%20date%22%7D%2C%7B%22id%22%3A%22total_pending%22%2C%22name%22%3A%22Balance%22%7D%2C%7B%22id%22%3A%22total_fee_with_waives_in_cents%22%2C%22name%22%3A%22Total%20Fees%22%7D%2C%7B%22id%22%3A%22total_paid_in_cents%22%2C%22name%22%3A%22Total%20Paid%22%7D%2C%7B%22id%22%3A%22renewal_status%22%2C%22name%22%3A%22Renewal%20Status%22%7D%5D&currentViewName=All%20applications&direction=desc&field=dateEntered";
export const DefaultViewName = "All applications";
//these values are used to filter permit applications
// the name field is equivalent to the elastic search field. Underscores replace spaces in the ES payload durning the call.
export const MainAdvancedFilters = [
  {
    typesId: "balance_due",
    name: "Balance Due",
    field_type: 2,
    type: "main",
  },
  {
    typesId: "submitted_at",
    name: "Submitted At",
    field_type: 7,
    type: "main",
  },
  {
    typesId: "subtotal",
    name: "Subtotal",
    field_type: 2,
    type: "main",
  },
  {
    typesId: "active_workflow_steps.title",
    name: "Active Workflow Steps",
    field_type: 0,
    type: "main",
  },
  {
    typesId: "expired_at",
    name: "Expired At",
    field_type: 7,
    type: "main",
  },
  {
    typesId: "total_paid_in_cents",
    name: "Total Paid In Cents",
    field_type: 2,
    type: "main",
  },
  {
    typesId: "issued_at",
    name: "Issued At",
    field_type: 7,
    type: "main",
  },
  {
    typesId: "primary_identifier",
    name: "Primary Identifier",
    field_type: 0,
    type: "main",
  },
  {
    typesId: "permit_number",
    name: "Permit Number",
    field_type: 0,
    type: "main",
  },
  {
    typesId: "renewal_status",
    name: "Renewal Status",
    field_type: 4,
    type: "main",
    options: [
      { key: "ineligible", value: "ineligible", text: "Not Eligible" },
      { key: "eligible", value: "eligible", text: "Eligible" },
      { key: "active_renewal", value: "active_renewal", text: "Active Renewal" },
      { key: "renewed", value: "renewed", text: "Renewed" },
      { key: "not_renewing", value: "not_renewing", text: "Not Renewing" },
      { key: "lapsed", value: "lapsed", text: "Lapsed" },
    ],
  },
  {
    typesId: "formal_number",
    name: "Formal Number",
    field_type: 0,
    type: "main",
  },
];

export const operators = [
  { value: "empty", key: "empty", text: "Is empty" },
  { value: "not_empty", key: "not_empty", text: "Is not empty" },
  { value: "contains", key: "contains", text: "Contains" },
  { value: "not_contain", key: "not_contain", text: "Does not contain" },
  { value: "equals", key: "equals", text: "Is equal to" },
  { value: "not_equal", key: "not_equal", text: "Is not equal to" },
  { value: "starts_with", key: "starts_with", text: "Starts with" },
  { value: "less_than", key: "less_than", text: "Is less than" },
  { value: "greater_than", key: "greater_than", text: "Is greater than" },
  { value: "is_any", key: "is_any", text: "Is" },
  { value: "not_any", key: "not_any", text: "Is not" },
  { value: "checked", key: "checked", text: "Is checked" },
  { value: "not_checked", key: "not_checked", text: "Is not checked" },
  { value: "is_between", key: "is_between", text: "Is between" },
  { value: "is_before", key: "is_before", text: "Is before" },
  { value: "is_after", key: "is_after", text: "Is after" },
];

export const conditionsOperators = [
  //short input - no validation - default
  [
    { value: "empty", key: "empty", text: "Is empty" },
    { value: "not_empty", key: "not_empty", text: "Is not empty" },
  ],
  //short input - email
  [
    { value: "empty", key: "empty", text: "Is empty" },
    { value: "not_empty", key: "not_empty", text: "Is not empty" },
  ],
  //short input - whole number
  [
    { value: "empty", key: "empty", text: "Is empty" },
    { value: "not_empty", key: "not_empty", text: "Is not empty" },
    { value: "less_than", key: "less_than", text: "Is less than" },
    { value: "greater_than", key: "greater_than", text: "Is greater than" },
    { value: "is_between", key: "is_between", text: "Is between" },
    { value: "equals", key: "equals", text: "Is equal to" },
  ],
  //short input - phone number
  [
    { value: "empty", key: "empty", text: "Is empty" },
    { value: "not_empty", key: "not_empty", text: "Is not empty" },
  ],
  //single select
  [
    { value: "empty", key: "empty", text: "Is empty" },
    { value: "not_empty", key: "not_empty", text: "Is not empty" },
    { value: "is_any", key: "is_any", text: "Is any" },
    { value: "not_any", key: "not_any", text: "Is not any" },
  ],
  //text area
  [
    { value: "empty", key: "empty", text: "Is empty" },
    { value: "not_empty", key: "not_empty", text: "Is not empty" },
  ],
  //google address geocoder
  [
    { value: "empty", key: "empty", text: "Is empty" },
    { value: "not_empty", key: "not_empty", text: "Is not empty" },
  ],
  //date picker
  [
    { value: "empty", key: "empty", text: "Is empty" },
    { value: "not_empty", key: "not_empty", text: "Is not empty" },
    { value: "is_before", key: "is_before", text: "Is before" },
    { value: "is_after", key: "is_after", text: "Is after" },
    { value: "is_between", key: "is_between", text: "Is between" },
    { value: "current_day", key: "current_day", text: "Is current day" },
    { value: "days_ago", key: "days_ago", text: "Is __ days ago" },
    { value: "weeks_ago", key: "weeks_ago", text: "Is __ weeks ago" },
    { value: "months_ago", key: "months_ago", text: "Is __ months ago" },
    { value: "days_ahead", key: "days_ahead", text: "Is __ days ahead" },
    { value: "weeks_ahead", key: "weeks_ahead", text: "Is __ weeks ahead" },
    { value: "months_ahead", key: "months_ahead", text: "Is __ months ahead" },
  ],
  //file uploader
  [
    { value: "empty", key: "empty", text: "Is empty" },
    { value: "not_empty", key: "not_empty", text: "Is not empty" },
  ],
  //checkbox
  [
    { value: "is_checked", key: "is_checked", text: "Is checked" },
    { value: "not_checked", key: "not_checked", text: "Is not checked" },
  ],
];

export const integrationMapping = {
  accela: {
    name: "Accela Civic Platform",
    icon: "/assets/integrations/Accela - Square Logo v2@2x.png",
    description: (
      <div>
        Features: Accela Integration for 2-way Sync of Requests.
        <div className='less-spaced-divider' />
        Requirements: Version 3.01 or higher of Accela.
        <div className='less-spaced-divider' />
        Instructional text in html format supporting paragraphs, bullets, hyperlinks and images with a Learn More link
        at the bottom that could open an external help article on another tab.
        <div className='less-spaced-divider' />
        <Link className='hover:tw-underline' to='/help'>
          Documentation
        </Link>
      </div>
    ),
  },
  assetessentials: {
    name: "Asset Essentials",
    icon: "/assets/integrations/Asset Essentials - Square@2x.png",
    description: (
      <div>
        Features: Asset Essentials Integration for 2-way Sync of Requests.
        <div className='less-spaced-divider' />
        Requirements: Version 3.01 or higher of Asset Essentials.
        <div className='less-spaced-divider' />
        Instructional text in html format supporting paragraphs, bullets, hyperlinks and images with a Learn More link
        at the bottom that could open an external help article on another tab.
        <div className='less-spaced-divider' />
        <Link className='hover:tw-underline' to='/help'>
          Documentation
        </Link>
      </div>
    ),
  },
  OpenGov: {
    name: "OpenGov",
    icon: "/assets/integrations/OpenGov - Square@2x.png",
    description: (
      <div>
        Features: OpenGov Integration for 2-way Sync of Requests.
        <div className='less-spaced-divider' />
        Requirements: Version 3.01 or higher of OpenGov.
        <div className='less-spaced-divider' />
        Instructional text in html format supporting paragraphs, bullets, hyperlinks and images with a Learn More link
        at the bottom that could open an external help article on another tab.
        <div className='less-spaced-divider' />
        <Link className='hover:tw-underline' to='/help'>
          Documentation
        </Link>
      </div>
    ),
  },
  Municity: {
    name: "Municity",
    icon: "/assets/integrations/Municity - Square@2x.png",
    description: (
      <div>
        Features: Municity Integration for 2-way Sync of Requests.
        <div className='less-spaced-divider' />
        Requirements: Version 3.01 or higher of Municity.
        <div className='less-spaced-divider' />
        Instructional text in html format supporting paragraphs, bullets, hyperlinks and images with a Learn More link
        at the bottom that could open an external help article on another tab.
        <div className='less-spaced-divider' />
        <Link className='hover:tw-underline' to='/help'>
          Documentation
        </Link>
      </div>
    ),
  },
  Infor: {
    name: "Infor",
    icon: "/assets/integrations/Infor - Square Logo@2x.png",
    description: (
      <div>
        Features: Infor Integration for 2-way Sync of Requests.
        <div className='less-spaced-divider' />
        Requirements: Version 3.01 or higher of Infor.
        <div className='less-spaced-divider' />
        Instructional text in html format supporting paragraphs, bullets, hyperlinks and images with a Learn More link
        at the bottom that could open an external help article on another tab.
        <div className='less-spaced-divider' />
        <Link className='hover:tw-underline' to='/help'>
          Documentation
        </Link>
      </div>
    ),
  },
  cityview: {
    name: "CityView",
    icon: "/assets/integrations/CityView - Square@2x.png",
    description: (
      <div>
        Features: CityView Integration for 2-way Sync of Requests.
        <div className='less-spaced-divider' />
        Requirements: Version 3.01 or higher of CityView.
        <div className='less-spaced-divider' />
        Instructional text in html format supporting paragraphs, bullets, hyperlinks and images with a Learn More link
        at the bottom that could open an external help article on another tab.
        <div className='less-spaced-divider' />
        <Link className='hover:tw-underline' to='/help'>
          Documentation
        </Link>
      </div>
    ),
  },
  cityworks: {
    name: "Cityworks",
    icon: "/assets/integrations/CityWorks - Square Icon@2x.png",
    description: (
      <div>
        Features: CityWorks Integration for 2-way Sync of Requests.
        <div className='less-spaced-divider' />
        Requirements: Version 3.01 or higher of CityWorks.
        <div className='less-spaced-divider' />
        Instructional text in html format supporting paragraphs, bullets, hyperlinks and images with a Learn More link
        at the bottom that could open an external help article on another tab.
        <div className='less-spaced-divider' />
        <Link className='hover:tw-underline' to='/help'>
          Documentation
        </Link>
      </div>
    ),
  },
  ftps: {
    name: "FTPS",
    icon: "/assets/integrations/FTPS - Square",
    description: (
      <div>
        Features: CityWorks Integration for 2-way Sync of Requests.
        <div className='less-spaced-divider' />
        Requirements: Version 3.01 or higher of CityWorks.
        <div className='less-spaced-divider' />
        Instructional text in html format supporting paragraphs, bullets, hyperlinks and images with a Learn More link
        at the bottom that could open an external help article on another tab.
        <div className='less-spaced-divider' />
        <Link className='hover:tw-underline' to='/help'>
          Documentation
        </Link>
      </div>
    ),
  },
  lucity: {
    name: "Lucity",
    icon: "/assets/integrations/Lucity - Square Logo@2x.png",
    description: (
      <div>
        Features: Lucty Integration for 2-way Sync of Requests.
        <div className='less-spaced-divider' />
        Requirements: Version 3.01 or higher of Lucity.
        <div className='less-spaced-divider' />
        Instructional text in html format supporting paragraphs, bullets, hyperlinks and images with a Learn More link
        at the bottom that could open an external help article on another tab.
        <div className='less-spaced-divider' />
        <Link className='hover:tw-underline' to='/help'>
          Documentation
        </Link>
      </div>
    ),
  },
  powerbi: {
    name: "PowerBI",
    icon: "/assets/integrations/Power BI - Square",
    description: (
      <div>
        Features: Power BI Integration for 2-way Sync of Requests.
        <div className='less-spaced-divider' />
        Requirements: Version 3.01 or higher of Power BI.
        <div className='less-spaced-divider' />
        Instructional text in html format supporting paragraphs, bullets, hyperlinks and images with a Learn More link
        at the bottom that could open an external help article on another tab.
        <div className='less-spaced-divider' />
        <Link className='hover:tw-underline' to='/help'>
          Documentation
        </Link>
      </div>
    ),
  },
  simplicity: {
    name: "Simplicity",
    icon: "/assets/integrations/Simplicity - Square",
    description: (
      <div>
        Features: Simplicity Integration for 2-way Sync of Requests.
        <div className='less-spaced-divider' />
        Requirements: Version 3.01 or higher of Simplicity.
        <div className='less-spaced-divider' />
        Instructional text in html format supporting paragraphs, bullets, hyperlinks and images with a Learn More link
        at the bottom that could open an external help article on another tab.
        <div className='less-spaced-divider' />
        <Link className='hover:tw-underline' to='/help'>
          Documentation
        </Link>
      </div>
    ),
  },
  energov: {
    name: "Tyler Energov",
    icon: "/assets/integrations/Tyler - Square Icon@2x.png",
    description: (
      <div>
        Features: Tyler Energov Integration for 2-way Sync of Requests.
        <div className='less-spaced-divider' />
        Requirements: Version 3.01 or higher of Tyler Energov.
        <div className='less-spaced-divider' />
        Instructional text in html format supporting paragraphs, bullets, hyperlinks and images with a Learn More link
        at the bottom that could open an external help article on another tab.
        <div className='less-spaced-divider' />
        <Link className='hover:tw-underline' to='/help'>
          Documentation
        </Link>
      </div>
    ),
  },
  zencity: {
    name: "ZenCity",
    icon: "/assets/integrations/ZenCity - Square",
    description: (
      <div>
        Features: ZenCity Integration for 2-way Sync of Requests.
        <div className='less-spaced-divider' />
        Requirements: Version 3.01 or higher of ZenCity.
        <div className='less-spaced-divider' />
        Instructional text in html format supporting paragraphs, bullets, hyperlinks and images with a Learn More link
        at the bottom that could open an external help article on another tab.
        <div className='less-spaced-divider' />
        <Link className='hover:tw-underline' to='/help'>
          Documentation
        </Link>
      </div>
    ),
  },
  edgesoft: {
    name: "Edgesoft",
    icon: "/assets/integrations/Edgesoft - Square Logo@2x.png",
    description: (
      <div>
        Features: Edgesoft Integration for 2-way Sync of Requests.
        <div className='less-spaced-divider' />
        Requirements: Version 3.01 or higher of CityView.
        <div className='less-spaced-divider' />
        Instructional text in html format supporting paragraphs, bullets, hyperlinks and images with a Learn More link
        at the bottom that could open an external help article on another tab.
        <div className='less-spaced-divider' />
        <Link className='hover:tw-underline' to='/help'>
          Documentation
        </Link>
      </div>
    ),
  },
  peregrine: {
    name: "Peregrine",
    icon: "/assets/integrations/Peregrine - Square Logo@2x.png",
    description: (
      <div>
        Features: Peregrine Integration for 1-way Sync of Requests.
        <div className='less-spaced-divider' />
        Requirements: Version 3.01 or higher of Peregrine.
        <div className='less-spaced-divider' />
        Instructional text in html format supporting paragraphs, bullets, hyperlinks and images with a Learn More link
        at the bottom that could open an external help article on another tab.
        <div className='less-spaced-divider' />
        <Link className='hover:tw-underline' to='/help'>
          Documentation
        </Link>
      </div>
    ),
  },
};
